export class StockTransferLandingFilterVM {
  toAccountNumber: string;
  toAccountName: string;
  fromAccountNumber: string;
  fromAccountName: string;
  requestNumber: string;
  productName: string;
  productNumber: string;
  customerPO: string;
  status: string;
}
